import { formatPhoneNumber } from './phoneFormatter'
import { shouldApplyEAEULogic, getEAEUDefaultValues } from '../../../../utils/eaeuHelper'
import i18n from '../../../../context/i18n'

export default function applyVoice(data, voiceData) {
    // Create a new object to avoid mutating the original state
    let result = {
        ...data,
        is_voice: true,
        _isVoiceInput: true,
        _needsEAEUCheck: true
    };
    
    if (voiceData.who) result.user_type = voiceData.who; 
    if (voiceData.pay_on_recieve) result.payment_on_receipt = voiceData.pay_on_recieve;
    if (voiceData.vat_rate) result.vat = (voiceData.vat_rate - 1) * 100;
    if (voiceData.city_from) {
        result.cityFromLabel = voiceData.city_from_label;
        result.cityFromMakeSearch = true;
    };
    if (voiceData.city_to) {
        result.cityToLabel = voiceData.city_to_label;
        result.cityToMakeSearch = true;
    }
    
    let hasPaymentOnReceipt = result.payment_on_receipt;
    
    if (voiceData.places) {
        let p = [];

        voiceData.places?.forEach((place, index) => {
            place.goods?.forEach((good) => {
                console.log(good);
                if (good.price) hasPaymentOnReceipt = true;
            });

            p.push({
                number: index + 1,
                height: place.height || 0,
                length: place.length || 0,
                width: place.width || 0,
                weight: place.weight || 0,
                goods: place.goods?.length && place.goods.length > 0 ? place.goods.map((good) => {
                    return {
                        name: good.name || i18n.t('basic:default_goods_name'),
                        article: good.article || '',
                        count: good.quantity || 1,
                        weight: good.weight || 0,
                        price: good.price || null,
                        insurance: good.insurance || 0,
                        vat_rate: good.vat_rate || result.vat_rate
                    }
                }) : [{
                    name: i18n.t('basic:default_goods_name'),
                    weight: 0,
                    count: 1,
                    article: "",
                    price: null,
                    insurance: 0,
                    vat: -1
                }]
            });
        });

        result.places = p;
        result.recaluclatePlaces = true;
        result.payment_on_receipt = hasPaymentOnReceipt;
    }

    if (voiceData.tariff_type) {
        result.v_tariff_type = voiceData.tariff_type;
        result.v_tariff_from = voiceData.tariff_from;
        result.v_tariff_to = voiceData.tariff_to;
    }

    if (voiceData.services) {
        result.additions = {...result.additions, ...voiceData.services};
    }

    // Deep copy delivery to avoid mutating the original
    const existingDelivery = data.delivery || {
        sender: { fio: '', contract_face: '', phones: [{ number: '', additional: '' }] },
        recipient: { fio: '', contract_face: '', phones: [{ number: '', additional: '' }] }
    };
    
    let newSender = {
        fio: existingDelivery.sender?.fio || '',
        contract_face: existingDelivery.sender?.contract_face || '',
        phones: (existingDelivery.sender?.phones || []).map(p => ({...p}))
    };
    
    let newRecipient = {
        fio: existingDelivery.recipient?.fio || '',
        contract_face: existingDelivery.recipient?.contract_face || '',
        phones: (existingDelivery.recipient?.phones || []).map(p => ({...p}))
    };

    if (voiceData.sender) {
        newSender.fio = voiceData.sender.FIO || newSender.fio;
        newSender.contract_face = voiceData.sender.contact_face || newSender.contract_face;
        if (typeof(voiceData.sender.phones) === "object" && voiceData.sender.phones?.length) {
            newSender.phones = voiceData.sender.phones.map((phone) => ({
                number: formatPhoneNumber(phone.number || ''),
                additional: phone.additional || ''
            }));
        }
    }

    if (voiceData.reciver) {
        newRecipient.fio = voiceData.reciver.FIO || newRecipient.fio;
        newRecipient.contract_face = voiceData.reciver.contact_face || newRecipient.contract_face;
        if (typeof(voiceData.reciver.phones) === "object" && voiceData.reciver.phones?.length) {
            newRecipient.phones = voiceData.reciver.phones.map((phone) => ({
                number: formatPhoneNumber(phone.number || ''),
                additional: phone.additional || ''
            }));
        }
    }

    result.delivery = {
        sender: newSender,
        recipient: newRecipient
    };

    if (voiceData.from_address) result.addressFrom = voiceData.from_address;
    if (voiceData.to_address) result.addressTo = voiceData.to_address;
    
    return result;
}